__webpack_require__.p = "https://bmidxbturkeyplpreprod.netlify.app/";